module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-plan-setup"
  }, [_vm._m(0), _c('div', {
    staticClass: "tabs-inner-content"
  }, [(_vm.plan) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Plan Name")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.name))]), _c('label', [_vm._v("Status")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))]), _c('label', [_vm._v("Color")]), _c('span', [_vm._v(_vm._s(_vm.item.color))]), _c('label', [_vm._v("Notice")]), _c('span', [_vm._v(_vm._s(_vm.item.notice))])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Duration (days)")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.duration))]), _c('legend', [_vm._v("The contractual commitment of the plan (days).")]), _c('label', [_vm._v("Subscription End")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.subscription_end))]), _c('label', [_vm._v("Max Drivers")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.max_drivers))]), _c('label', [_vm._v("Renewable")]), _c('span', {
    staticClass: "fa fa-check",
    class: {
      'success-text': _vm.item.renewable
    }
  }), _c('label', [_vm._v("Featured")]), _c('span', {
    staticClass: "fa fa-check",
    class: {
      'success-text': _vm.item.featured
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-12"
  }, [_c('label', [_vm._v("Description")]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.plan.description)
    }
  })])])]), _c('div', {
    staticClass: "columns small-12 large-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Cost"), _c('div', {
    staticClass: "help-text"
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(_vm.plan.cost))) + " included vat")])])]), (_vm.item.renewable) ? _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Billing Cycle (days)")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.billing_cycle))])]) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-6"
  }, [_c('label', [_vm._v("Active From")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.valid_from))])]), _c('div', {
    staticClass: "columns large-6"
  }, [_c('label', [_vm._v("Active To")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.valid_to))])])]), (_vm.item.toc) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Toc")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v("T" + _vm._s(_vm.item.toc.id) + " " + _vm._s(_vm.item.toc.name))])])]) : _vm._e(), (_vm.item.picture) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column",
    style: (_vm.planPictureStyle)
  })]) : _vm._e()])]) : _vm._e()]), (_vm.$route.params.id && _vm.plan !== null) ? _c('div', {
    staticClass: "plan-reservation-rates"
  }, [_c('TabHeaders', {
    attrs: {
      "tabs": ['Reservation Rates', ("Logs (" + (_vm.plan.logs.length) + ")")],
      "id": "plan-things",
      "activeIndex": 0
    }
  }, [_c('TabContent', {
    staticClass: "p-0",
    attrs: {
      "headerName": "Reservation Rates",
      "active": true
    }
  }, [_c('PlanReservationRates')], 1), _c('TabContent', {
    attrs: {
      "headerName": ("Logs (" + (_vm.plan.logs.length) + ")")
    }
  }, [_c('accordion', _vm._l((_vm.plan.logs), function(l) {
    return _c('accordion-item', {
      attrs: {
        "title": _vm.$dateFormat(l.date.date, "DD-MM-YYYY HH:mm:ss") + ' | ' + l.action
      }
    }, [_c('log', {
      attrs: {
        "item": l
      }
    })], 1)
  }), 1)], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-bar"
  }, [_c('h2', [_vm._v("Plan settings")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d50fbcf0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/PlanSetup.vue
// module id = 2496
// module chunks = 1